import { render } from "./ListDemo.vue?vue&type=template&id=3459464e&scoped=true"
import script from "./ListDemo.vue?vue&type=script&lang=js"
export * from "./ListDemo.vue?vue&type=script&lang=js"

import "./ListDemo.vue?vue&type=style&index=0&id=3459464e&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3459464e"]])

export default __exports__